import {
  Button, Form, message, Modal, Pagination, Space, Table,
} from 'antd';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { deleteCustomer, getCustomers, resetCustomerPassword } from '../../services/customerServices';
import { customersTableColumns } from '../../../../utils/tableColumns';
import TextInput from '../../inputs/TextInput';
import useTranslation from '../../../hooks/translation/useTranslation';

function Customers() {
  const { trans } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const fetchData = async (page, value) => {
    setLoading(true);
    const res = await getCustomers({
      page: page || 1,
      limit: 10,
      ...value,
    });
    setData(res);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    Modal.confirm({
      title: trans('do_you_want_to_delete'),
      onOk: async () => {
        await deleteCustomer(id);
        fetchData(
          data?.meta?.currentPage,
        );
      },
    });
  };

  const handleResetPassword = async (id) => {
    try {
      message.loading(trans('reseting_password'));

      await resetCustomerPassword(id);

      message.success(trans('password_successfully_reseted'));
    } catch {
      message.error(trans('password_not_reseted'));
    }
  };
  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>

      <Form onFinish={() => fetchData(data?.meta?.currentPage, form.getFieldsValue())} layout="vertical" className="grid grid-cols-3 gap-x-4 " form={form}>
        <TextInput label={trans('search')} name="search" />
        <Form.Item label=" " className="w-full">
          <Button className="w=full" type="primary" htmlType="submit">{trans('search')}</Button>
        </Form.Item>
      </Form>

      <Button type="primary" onClick={() => navigate('/admin/customers/add')}>{trans('add_customer')}</Button>
      <div className="overflow-table">
        <Table
          dataSource={data?.data?.map((item) => ({
            ...item,
            reset_password:
  <Button type="primary" onClick={() => handleResetPassword(item.id)}>
    {trans('reset_password')}
  </Button>,
            edit: <Link to={`/admin/customers/${item.id}/edit`}><Button>{trans('edit')}</Button></Link>,
            delete:
  <Button onClick={() => handleDelete(item.id)} danger>
    {trans('delete')}
  </Button>,
          }))}
          columns={customersTableColumns.map(
            (col) => ({
              ...col,
              title: trans(col.title),
            }),
          )}
          pagination={false}
          loading={loading}
        />
      </div>
      {data?.meta && (
      <Pagination
        total={data?.meta?.totalItems}
        pageSize={data?.meta?.itemsPerPage}
        showSizeChanger={false}
        current={Number(data?.meta?.currentPage)}
        onChange={(e) => fetchData(e)}
      />
      )}
    </Space>
  );
}

export default Customers;
